import {
  AddInvoice, AppProvider,
  AppVersion,
  ChatModal,
  ElementorWidgetsGqlInputStore,
  ElementorWidgetsTitleGqlStore, InvoiceList,
  LoginLogoutContainerWithKeycloakProvider,
  MenuAvatar,
  NoteForm,
  ProductButton,
  ProfileCompletion,
  ProfileContainer,
  ProfileDescriptionInput,
  ProfileList,
  ProfileSkillsFrom, ProjectDetails,
  ProjectForm,
  ProjectList, ProjectProductList,
  PublicProfileConsent,
  PublicProfiles,
} from '@betrue/ui';
import {WebComponentWrapper} from "@betrue/common";

WebComponentWrapper(
  'elementor-widgets-input',
  ElementorWidgetsGqlInputStore,
  AppProvider)

WebComponentWrapper(
  'elementor-widgets-title',
  ElementorWidgetsTitleGqlStore,
  AppProvider)

WebComponentWrapper('bt-login-logout',
  LoginLogoutContainerWithKeycloakProvider,
  AppProvider)

WebComponentWrapper('bt-profile-skills-form',
  ProfileSkillsFrom, AppProvider)

WebComponentWrapper('bt-profile-infos',
  ProfileContainer, AppProvider)

WebComponentWrapper('bt-menu-avatar',
  MenuAvatar, AppProvider)

WebComponentWrapper('bt-version',
  AppVersion, AppProvider)

WebComponentWrapper('bt-profile-description',
  ProfileDescriptionInput, AppProvider)

WebComponentWrapper('bt-profile-list',
  ProfileList, AppProvider)

WebComponentWrapper('bt-public-profile-consent',
  PublicProfileConsent, AppProvider)

WebComponentWrapper('bt-public-profiles',
  PublicProfiles, AppProvider)

WebComponentWrapper('bt-profile-completion',
  ProfileCompletion, AppProvider)

WebComponentWrapper('bt-add-invoice',
  AddInvoice, AppProvider)

WebComponentWrapper('bt-invoice-list',
  InvoiceList, AppProvider)

WebComponentWrapper('bt-chat-modal',
  ChatModal, AppProvider)

WebComponentWrapper('bt-product-button',
  ProductButton, AppProvider)

WebComponentWrapper('bt-project-list',
  ProjectList, AppProvider)

WebComponentWrapper('bt-project-form',
  ProjectForm, AppProvider)

WebComponentWrapper('bt-project-product-list',
  ProjectProductList, AppProvider)

WebComponentWrapper('bt-project-details',
  ProjectDetails, AppProvider)

WebComponentWrapper('bt-notes',
  NoteForm, AppProvider)
//V1.XXxX



